/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { OasResponse } from '../../models/OasResponse';
import { OasResponses } from '../../models/OasResponses';

/**
 * Constructor.
 * @class
 * @extends OasResponses
 * @author eric.wittmann@gmail.com
 */
export class Oas30Responses extends OasResponses {
    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.openapi.models.OasResponses#createResponse(java.lang.String)
     * @param {string} statusCode
     * @return {OasResponse}
     */
    public createResponse(statusCode : string) : OasResponse {
        let response : OasResponse = new Oas30Response(statusCode);
        response._ownerDocument = this.ownerDocument();
        response._parent = this;
        return response;
    }
}
Oas30Responses["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Responses";
Oas30Responses["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IIndexedNode"];





import { Oas30Response } from './Oas30Response';

